import classNames from "classnames";
import { useDispatch } from "react-redux";
import React, { useState, useCallback, useEffect } from "react";
import { isMobile } from "react-device-detect";

import CatchStoryHiddenConfirmLayer from "components/boards/post/catchstory/layer/CatchStoryHiddenConfirmLayer";
import CatchStoryHiddenReasonLayer from "components/boards/post/catchstory/layer/CatchStoryHiddenReasonLayer";

import {fetchStoryHiddenCheck} from "actions/vod.storyHidden.action";
import { setClickLogapi } from "helpers";

import { toastr } from "components/toastr";

export const LAYER = {
	CONFIRM: "CONFIRM",
	REASON: "REASON",
};

const CatchStoryHiddenLayer = ({ vod, close, closeLayer, top = 0, left = "unset", right = "unset" }) => {

    // 현재 레이어 페이지
	const [layer, setLayer] = useState(LAYER.CONFIRM);
    const [storyHiddenInfo, setStoryHiddenInfo] = useState({
        result : 0,
        read_cnt : 0,
        catch_cnt : 0,
        copyrighter_nick : "",
    });
    const [hiddenFlag, setHiddenFlag] = useState("hidden"); // PC에서 삭제 1차 방어 레이어를 띄워지기 전 살짝 빈 div가 보이기때문에 hidden처리

    const dispatch = useDispatch();

    // 스토리 삭제 조회 API 호출
    useEffect(() => {
        // 삭제하기 버튼 눌렀을 때 click 로그
        setClickLogapi("story_separate_list", {contents_type : "catch_story", action : "click", button_type : "to_delete"});

        const callAPi = async () => {
            const storyHiddenInfo = await dispatch(fetchStoryHiddenCheck(vod.story_idx, "get", false));
            // API 조회 성공
            if(storyHiddenInfo.hasOwnProperty('result')){
                setClickLogapi("story_separate_delete_popup1", {contents_type : "catch_story", action : "view", button_type : ""});
                setStoryHiddenInfo(storyHiddenInfo);
                setHiddenFlag("visible");
            // API 조회 실패
            } else {
                toastr.success(storyHiddenInfo.message, {
                    timeOut: 2000,
                });
                close(closeLayer);
            }
        }
        callAPi();
    }, []);

	// 레이어 팝업 클릭 시 닫히지 않도록 처리
	const handleClickLayer = useCallback((event) => {
		event.stopPropagation();
		event.nativeEvent.stopImmediatePropagation();
	}, []);

    return (
        <div
            className={classNames(isMobile ? "ui-pop-m" : "ui-pop", layer==LAYER.CONFIRM ? "storyDelete active" : "vod-delete vod-story-delete storyDeleteTxt")}
            onClick={handleClickLayer} style={{visibility:`${hiddenFlag}`}}
        >
            {/* 캐치 스토리 삭제 확인 레이어 */}
            {storyHiddenInfo.result != 0 && layer === LAYER.CONFIRM && <CatchStoryHiddenConfirmLayer vod={vod} onChangeLayer={setLayer} storyHiddenInfo={storyHiddenInfo} close={close} closeLayer={closeLayer} />}

            {/* 캐치 스토리 삭제 사유 레이어 */}
            {layer === LAYER.REASON && <CatchStoryHiddenReasonLayer storyHiddenInfo={storyHiddenInfo} close={close} closeLayer={closeLayer}/>}
        </div>
    );
};

export default CatchStoryHiddenLayer;
